import type { TextColor, ColorPalette, AdditionalColors } from '@acceligentllc/shared/enums/color';

export const getColorBackgroundClass = (
	color: Nullable<ColorPalette | AdditionalColors | string> | undefined,
	defaultToGrey: boolean = false,
	defaultClass?: string
) => {
	if (!color) {
		if (defaultClass) {
			return defaultClass;
		}

		return defaultToGrey ? 'bg-pastel-greyUndefined' : '';
	}
	return `bg-pastel-${color.toLowerCase()}`;
};

export const getColorTextClass = (
	color: Nullable<ColorPalette | AdditionalColors | TextColor | string> | undefined,
	defaultToGrey: boolean = false,
	defaultClass?: string
) => {
	if (!color) {
		if (defaultClass) {
			return defaultClass;
		}

		return defaultToGrey ? 'text-pastel-greyUndefined' : '';
	}
	return `text-pastel-${color.toLowerCase()}`;
};
